<template>
    <div class="matter-container" v-show="showAll">
        <div class="comp-header">
            <h3>特殊事项</h3>
            <el-button type="primary" icon="el-icon-plus" @click="handleMenuClick('add')">新增</el-button>
        </div>
        <!-- 卡片 -->
        <ul class="card-outer">
            <li class="box" v-for="item in dataList" :key="item.id">
                <el-popover placement="bottom" :trigger="$utils.isMobile() ? 'click' : 'hover'">
                    <ul class="corner-operation">
                        <li @click="handleMenuClick('edit', item)">编辑</li>
                        <li @click="handleMenuClick('del', item)">删除</li>
                    </ul>
                    <i slot="reference" class="iconfont icon-gengduo more-icon"></i>
                </el-popover>
                <div class="title-line">
                    <img src="~@/assets/image/school/icon-contract.png">
                    <span class="name">{{ item.title }}</span>
                </div>
                <div class="infos">
                    <div>
                        <label>创建人：</label>
                        <span>{{ item.createdByName || '--' }}</span>
                    </div>
                    <div>
                        <label>创建时间：</label>
                        <span>{{ item.createdTimeStr }}</span>
                    </div>
                    <div>
                        <label>学校：</label>
                        <span>{{ item.schoolName }}</span>
                    </div>
                    <div>
                        <label>说明：</label>
                        <span v-html="item.content"></span>
                    </div>
                </div>
            </li>
        </ul>

        <!-- 新增/编辑 -->
        <el-drawer :title="`${editId ? '编辑' : '新增'}特殊事项`" :visible.sync="addDrawer" :direction="$utils.isMobile() ? 'btt' : 'rtl'" custom-class="add-drawer"
            :size="$utils.isMobile() ? '60%' : '35rem'" :wrapperClosable="false">
            <el-form ref="addForm" :model="addForm" :rules="addRules" label-width="100px" :label-position="$utils.isMobile() ? 'top' : 'left'">
                <el-form-item label="标题" prop="title">
                    <el-input v-model="addForm.title" placeholder="请输入" clearable show-word-limit maxlength="250" class="pad60"></el-input>
                </el-form-item>
                <el-form-item label="学校" prop="sId">
                    <el-select v-model="addForm.sId" placeholder="请选择" filterable style="width: 100%">
                        <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="说明" prop="content">
                    <el-input v-model="addForm.content" type="textarea" clearable autosize></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="loadAdd" @click="confirmAdd" style="width: 110px;">保存</el-button>
                </el-form-item>
            </el-form>
            <drawer-close v-if="!$utils.isMobile()" :visible="addDrawer" right="35rem" @close="addDrawer = false"></drawer-close>
        </el-drawer>

        <!-- 删除 -->
        <delConfirm :visible.sync="delDrawer" title="删除特殊事项" :id="editId" :sname="editName" @change="fetchData" />
    </div>
</template>

<script>
import { findSpecialMatterList, addSpecialMatter, updateSpecialMatter } from '@/api/home/index.js';
import { mapState } from 'vuex';

export default {
    name: 'SpecialMatter',
    components: {
        delConfirm: () => import('@/views/customer/components/delConfirm.vue')
    },
    data() {
        return {
            showAll: true,
            dataList: [],
            // 编辑id
            editId: '',
            editName: '',
            // 新增/编辑抽屉
            addDrawer: false,
            addForm: {
                title: '',
                sId: '',
                content: '',
            },
            addRules: {
                title: [{ required: true, message: "请输入标题", trigger: "blur" }],
                sId: [{ required: true, message: "请选择学校", trigger: "blur" }],
            },
            loadAdd: false,
            // 删除弹窗
            delDrawer: false,
        }
    },
    computed: {
        ...mapState(["schoolList"]),
    },
    created() {
        // 能看到此模块的账号：总经理=2、市场支持=5、财务=4
        if ([2, 5, 4].indexOf(this.$store.state.userData.type) > -1) {
            this.fetchData();
        } else {
            this.showAll = false;
        }
    },
    methods: {
        fetchData() {
            findSpecialMatterList().then(res => {
                this.dataList = [];
                res.data.forEach(item => {
                    this.dataList.push({
                        ...item,
                        content: item.content.replaceAll('\n', '<br>')
                    })
                })
            }).catch(err => {
                if (err.status === 888) return;
                this.dataList = [];
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 新增/编辑/删除
        handleMenuClick(type, row) {
            if (type == "add") {
                this.loadAdd = false;
                this.editId = "";
                this.addDrawer = true;
                this.addForm = {
                    title: '',
                    sId: '',
                    content: '',
                };
                this.$nextTick(() => {
                    this.$refs.addForm?.clearValidate();
                })
            } else if (type == "edit") {
                this.loadAdd = false;
                this.editId = row.id;
                this.addDrawer = true;
                this.addForm = {
                    title: row.title,
                    sId: row.sId,
                    content: row.content.replaceAll('<br>', '\n'),
                };
                this.$nextTick(() => {
                    this.$refs.addForm?.clearValidate();
                })
            } else if (type == "del") {
                this.editId = row.id;
                this.editName = row.title;
                this.delDrawer = true;
            }
        },
        confirmAdd() {
            this.loadAdd = true;
            this.$refs.addForm.validate((valid) => {
                if (valid) {
                    let reqApi = this.editId ? updateSpecialMatter : addSpecialMatter;
                    reqApi({ id: this.editId, ...this.addForm }).then(res => {
                        this.$MessageBox.MessageSuccess(res.msg);
                        this.loadAdd = false;
                        this.addDrawer = false;
                        this.fetchData();
                    }).catch((err) => {
                        this.$MessageBox.MessageWarning(err.data.msg);
                        this.loadAdd = false;
                    });
                } else {
                    this.loadAdd = false;
                    return;
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.box {
    padding: 20px 1.38rem;
    background-color: #fff;
    box-shadow: 0px 1px 6px 1px rgba(4, 32, 93, 0.06);
    border-radius: 12px;
}
.matter-container {
    margin-top: 30px;
    .comp-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        .el-button {
            border-radius: 12px;
        }
    }
    .card-outer {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        list-style: none;
        .box {
            position: relative;
            width: calc((100% - 40px) / 3);
            .more-icon {
                position: absolute;
                right: 1rem;
                top: 0.6rem;
                font-size: 1.8rem;
                outline: none;
                cursor: pointer;
            }
            .title-line {
                display: flex;
                align-items: center;
                padding-bottom: 12px;
                padding-right: 1.5rem;
                border-bottom: 1px dashed #dddddd;
                font-size: 1.1rem;
                font-weight: 600;
                > img {
                    width: 2.2rem;
                    height: 2.2rem;
                    margin-right: 8px;
                }
                .name {
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    overflow: hidden;
                }
            }
            .infos {
                > div {
                    display: flex;
                    margin-top: 0.8rem;
                    label {
                        display: inline-block;
                        min-width: 5.6rem;
                    }
                }
            }
        }
    }
    /*移动端*/
    @media only screen and (max-width: 767px) {
        .card-outer {
            flex-direction: column;
            > .box {
                width: 100%;
            }
        }
    }
}
</style>